<template>
  <div class="contact-mac">
    <header>
      <img src="../assets/img/联系我们_banner.png" class="banner" />
      <div class="main">
        <div class="left"></div>
        <div class="center">
          <h1>联系我们</h1>
        </div>
        <div class="right"></div>
      </div>
    </header>

    <main>
      <div class="main">
        <div class="left"></div>
        <div class="center" contentWrapper>
          <!-- <img src="../assets/img/contact/btn_line.png" alt="" /> -->
          <div class="branch" style="margin-top: 100px">
            <ul>
              <li
                :class="currentIndex == index ? 'active' : ''"
                v-for="(item, index) in list"
                :key="item.id"
                @click="change(index)"
                id="change"
              >
                <p style="padding-bottom: 12px">
                  {{ item.title }}
                </p>
                <!-- <span id="change1"></span> -->
              </li>
            </ul>
          </div>
          <div class="line">
            <div id="sline" class="sline"></div>
          </div>
          <div
            class="change"
            :class="currentIndex == index ? 'current' : ''"
            :key="item.id"
            v-for="(item, index) in list"
          >
            <h1>{{ item.title2 }}</h1>
            <!-- <p>
              地址：深圳市盐田区沙头角深盐路保发大厦5楼整层<br />总机：0755-83932176<br />市场中心直线（网约车产品）：0755-83934003<br />市场二中心直线（车联网、两客一危）：0755-83932665<br />传真：0755-83932552<br />全国服务热线：4001&nbsp;837544<br />公司网站：www.szce.com<br />E-mail:&nbsp;&nbsp;changen&#64;szce.com
            </p> -->
            <p>
              <!-- 地址： -->
              {{ item.address }}<br />
              <!-- 总机： -->
              {{ item.phone1 }}<br />
              <!-- {{ item.phonenew }}<br /> -->
              <!-- 市场中心直线（网约车产品）： -->
              <!-- {{ item.phone2 }}<br /> -->
              <!-- 市场二中心直线（车联网、两客一危）： -->
              <!-- {{ item.phone3 }}<br /> -->
              <!-- 传真： -->
              <!-- {{ item.phone4 }}<br /> -->
              <!-- 全国服务热线： -->
              <!-- {{ item.phone5 }}<br /> -->
              <!-- 公司网站： -->
              {{ item.website }}<br />
              <!-- E-mail:&nbsp;&nbsp;changen&#64;szce.com -->
              {{ item.eMaill }}
            </p>
          </div>
        </div>
        <div class="right"></div>
      </div>
    </main>

    <Footer></Footer>
  </div>
</template>
<script>
import Footer from '../components/footer.vue'
export default {
  components: { Footer },
  name: 'contact',
  data () {
    return {
      currentIndex: 0, //表示当前选项卡
      list: [
        {
          id: 1, //用来代表每一个对象
          title: '深圳总部', //标题
          title2: '深圳昌恩智能股份有限公司',
          address: '地址：深圳市盐田区深盐路南保发大厦5楼',
          phone1: '总机：0755-83932176',
          phonenew: '智慧交通事业部：13691705316',
          // phone2: "市场中心直线（网约车产品）：0755-83934003",
          // phone3: "市场二中心直线（车联网、两客一危）：0755-83932665",
          website: '公司网站：www.szce.com',
          eMaill: 'E-mail:  changen@szce.com'
        },
        {
          id: 2, //用来代表每一个对象
          title: '深圳市昌恩碳中科技有限公司', //标题
          title2: '深圳市昌恩碳中科技有限公司',
          address:
            '地址：深圳市福田区沙头街道天安社区泰然四路25号天安创新科技广场一期B座1310B.C',
          phone1: '总机：0755-83932176'
          // phone2: "市场中心直线（网约车产品）：0755-83934003",
          // phone3: "市场二中心直线（车联网、两客一危）：0755-83932665"
          // phone5: "全国服务热线：4001 837544",
          // website: "www.szce.com",
          // eMaill: "E-mail:  changen@szce.com"
        },
        {
          id: 3, //用来代表每一个对象
          title: '智慧交通服务中心', //标题
          title2: '智慧交通服务中心',
          address: '地址：深圳市盐田区深盐路保发大厦1楼',
          phone1: '电话：13751002110'
          // phone2: "市场中心直线（网约车产品）：0755-83934003",
          // phone3: "市场二中心直线（车联网、两客一危）：0755-83932665"
          // phone5: "全国服务热线：4001 837544",
          // website: "www.szce.com",
          // eMaill: "E-mail:  changen@szce.com"
        },
        // {
        //   id: 4, //用来代表每一个对象
        //   title: '广东昌恩电子科技', //标题
        //   title2: '广东昌恩电子科技有限公司',
        //   address: '地址：梅县畲江镇广州（梅州）产业转移工业园内',
        //   phone1: '总机：0753-2210988'
        //   // phone2: "市场中心直线（网约车产品）：0755-83934003",
        //   // phone3: "市场二中心直线（车联网、两客一危）：0755-83932665"
        //   // phone5: "全国服务热线：4001 837544",
        //   // website: "www.szce.com",
        //   // eMaill: "E-mail:  changen@szce.com"
        // },
        // {
        //   id: 5, //用来代表每一个对象
        //   title: '广州昌恩智能科技', //标题
        //   title2: '广州昌恩智能科技有限公司',
        //   address:
        //     '地址： 广州市白云区广州民营科技园科泰二路13-19号高新区产业园',
        //   phone1: '总机：13922379181'
        //   // phone2: "市场中心直线（网约车产品）：0755-83934003",
        //   // phone3: "市场二中心直线（车联网、两客一危）：0755-83932665"
        //   // phone5: "全国服务热线：4001 837544",
        //   // website: "www.szce.com",
        //   // eMaill: "E-mail:  changen@szce.com"
        // },
        {
          id: 6, //用来代表每一个对象
          title: '成都分公司', //标题
          title2: '深圳昌恩智能股份有限公司成都分公司',
          address: '地址：成都市青羊区正府街172号证大正府3201',
          phone1: '总机：028-66516388'
          // phone2: "市场中心直线（网约车产品）：0755-83934003",
          // phone3: "市场二中心直线（车联网、两客一危）：0755-83932665"
          // phone5: "全国服务热线：4001 837544",
          // website: "www.szce.com",
          // eMaill: "E-mail:  changen@szce.com"
        },
        {
          id: 7, //用来代表每一个对象
          title: '东莞分公司', //标题
          title2: '深圳昌恩智能股份有限公司东莞分公司',
          address: '地址：广东省东莞市万江街道金鳌路9号1039室',
          phone1: '总机：0769-22289371'
          // phone2: "市场中心直线（网约车产品）：0755-83934003",
          // phone3: "市场二中心直线（车联网、两客一危）：0755-83932665"
          // phone5: "全国服务热线：4001 837544",
          // website: "www.szce.com",
          // eMaill: "E-mail:  changen@szce.com"
        },
        {
          id: 8, //用来代表每一个对象
          title: '深圳市立进供应链有限公司', //标题
          title2: '深圳市立进供应链有限公司',
          address: '地址：深圳市盐田区深盐路南保发大厦5楼',
          phone1: '电话：0755-83932176'
        }
        // {
        //   id: 8, //用来代表每一个对象
        //   title: '福建分公司', //标题
        //   title2: '深圳昌恩智能股份有限公司福建分公司',
        //   address:
        //     '地址：福建省福州市鼓楼区软件大道89号福州软件园F区2号楼13层02室',
        //   phone1: '总机：0591-83852953'
        //   // phone2: "市场中心直线（网约车产品）：0755-83934003",
        //   // phone3: "市场二中心直线（车联网、两客一危）：0755-83932665"
        //   // phone5: "全国服务热线：4001 837544",
        //   // website: "www.szce.com",
        //   // eMaill: "E-mail:  changen@szce.com"
        // },
        // {
        //   id: 9, //用来代表每一个对象
        //   title: '河源分公司', //标题
        //   title2: '深圳昌恩智能股份有限公司河源分公司 ',
        //   address: '地址：河源市丝茅塘拆迁安置点第二区D2栋第十二卡三楼',
        //   phone1: '总机：13825205601'
        //   // phone2: "市场中心直线（网约车产品）：0755-83934003",
        //   // phone3: "市场二中心直线（车联网、两客一危）：0755-83932665"
        //   // phone5: "全国服务热线：4001 837544",
        //   // website: "www.szce.com",
        //   // eMaill: "E-mail:  changen@szce.com"
        // }
        // {
        //   id: 9, //用来代表每一个对象
        //   title: "江苏分部", //标题
        //   address: "地址：深圳市盐田区沙头角深盐路保发大厦5楼整层",
        //   phone1: "总机：0755-83932176",
        //   phone2: "市场中心直线（网约车产品）：0755-83934003",
        //   phone3: "市场二中心直线（车联网、两客一危）：0755-83932665",
        //   phone4: "传真：0755-83932552",
        //   phone5: "全国服务热线：4001 837544",
        //   website: "www.szce.com",
        //   eMaill: "E-mail:  changen@szce.com"
        // },
        // {
        //   id: 10, //用来代表每一个对象
        //   title: "福建分部", //标题
        //   address: "地址：深圳市盐田区沙头角深盐路保发大厦5楼整层",
        //   phone1: "总机：0755-83932176",
        //   phone2: "市场中心直线（网约车产品）：0755-83934003",
        //   phone3: "市场二中心直线（车联网、两客一危）：0755-83932665",
        //   phone4: "传真：0755-83932552",
        //   phone5: "全国服务热线：4001 837544",
        //   website: "www.szce.com",
        //   eMaill: "E-mail:  changen@szce.com"
        // },
        // {
        //   id: 11, //用来代表每一个对象
        //   title: "深汕办事处", //标题
        //   address: "地址：深圳市盐田区沙头角深盐路保发大厦5楼整层",
        //   phone1: "总机：0755-83932176",
        //   phone2: "市场中心直线（网约车产品）：0755-83934003",
        //   phone3: "市场二中心直线（车联网、两客一危）：0755-83932665",
        //   phone4: "传真：0755-83932552",
        //   phone5: "全国服务热线：4001 837544",
        //   website: "www.szce.com",
        //   eMaill: "E-mail:  changen@szce.com"
        // }
      ]
    }
  },
  methods: {
    change (index) {
      // if(index >= 1){
      //   var mleft = document.getElementById("sline");
      //   var endLeft = index * 119;
      //   console.log(endLeft+'===')
      //   mleft.style.marginLeft=endLeft + "px";
      // }else{
      //   var mleft = document.getElementById("sline");
      //   var endLeft = 0;
      //   console.log(endLeft+'===')
      //   mleft.style.marginLeft=endLeft + "px";
      // }
      //用来实现切换功能
      //实现选项卡 切换操作 - 本质就是操作类名
      // 通过currentIndex操作
      this.currentIndex = index
    }
  }
}
</script>
<style scoped>
@media screen and (max-width: 1201px) {
  .main {
    width: 974px !important;
    margin: 0 auto;
  }
  .center {
    width: 100% !important;
  }
  header {
    height: 313px !important;
  }
  header .main .center h1 {
    font-size: 30px !important;
    padding-top: 151px !important;
  }
  .center {
    width: 100% !important;
    text-align: center;
  }
  main img {
    width: 913px !important;
    margin: 32px auto 0px !important;
    padding-left: 0px !important;
  }

  main .branch ul {
    display: flex !important;
    justify-content: space-between !important;
  }
  main .branch ul li {
    width: 63px !important;
    font-size: 13px !important;
  }
  .main .current {
    text-align: initial !important;
  }
  .current h1 {
    font-size: 13px !important;
  }
  .main .current p {
    font: 12px !important;
  }
}

@media screen and (max-width: 1080px) {
  .main {
    width: 883px !important;
  }
  .center {
    width: 100% !important;
  }
  header {
    height: 281px !important;
  }
  header .main .center h1 {
    font-size: 27px !important;
    padding-top: 127px !important;
  }
  .center {
    width: 100% !important;
    text-align: center;
  }
  main img {
    width: 821px !important;
    margin: 29px auto 0px !important;
    padding-left: 0px !important;
  }
  main .branch ul {
    display: flex !important;
    justify-content: space-between !important;
  }
  main .branch ul li {
    width: 56px !important;
    font-size: 12px !important;
  }
  .main .current {
    text-align: initial !important;
  }
  .current h1 {
    font-size: 12px !important;
  }
  .main .current p {
    font: 12px !important;
  }
}
@media screen and (max-width: 1600px) and (min-width: 1200px) {
  /* 1470 */
  .main {
    width: 1200px !important;
    margin: 0 auto;
  }

  .center {
    width: 100% !important;
  }
  header {
    height: 383px !important;
  }
  header .main .center h1 {
    font-size: 37px !important;
    padding-top: 186px !important;
  }
  .center {
    width: 100% !important;
    text-align: center;
  }
  main img {
    width: 1118px !important;
    margin: 39px auto 0px !important;
    padding-left: 0px !important;
  }
  main .branch ul {
    display: flex !important;
    justify-content: space-between !important;
  }
  main .branch ul li {
    width: 77px !important;
    font-size: 15px !important;
  }
  .main .current {
    text-align: initial !important;
  }
  .current h1 {
    font-size: 15px !important;
  }
  .main .current p {
    font: 12px !important;
  }
}

.center {
  width: 1470px;
  margin: 0 auto;
}
header {
  height: 500px;
}

header h1 {
  padding-top: 243px;
  text-align: center;
  font-size: 39px;
  color: #ffffff;
  line-height: 53px;
  letter-spacing: 10px;
}
main {
  margin-bottom: 99.9936px;
}
main img {
  margin: 50.9952px auto 0px;
  padding-left: 31px;
  width: 97%;
  height: 153px;
}

main .branch ul {
  display: flex;
  justify-content: space-between;
  /* justify-content: space-evenly; */
}
main .branch ul li {
  position: relative;
  display: inline-block;
  /* margin-right: 45px; */
  width: 81px;
  text-align: center;

  /* height: 146px; */
  border-radius: 3.9936px;
  background-color: #f1f4fb;
  cursor: pointer;
  padding-top: 19.008px;
}

main .branch li #change1 {
  display: none;
  /* top: 209px; */
  top: 362px;
  position: absolute;
  content: '';
  width: 100%;
  height: 4px;
  background-color: #140047;
}

main .branch ul li:nth-last-child(1) {
  margin-right: 0px;
}

main .branch ul li.active {
  letter-spacing: 0.100032px;
  background-color: #140047;
}
main .branch ul .active p {
  color: #ffffff;
}
main .branch ul .active #change1 {
  display: block;
}

main .branch ul li p .active {
  color: #ffffff;
}

main .branch ul li p {
  color: #140047;
  display: block;
  font-size: 20.0064px;
  writing-mode: vertical-rl;
  -webkit-writing-mode: vertical-rl;
  -ms-writing-mode: vertical-rl;
  margin: 0 auto;
  /* padding-top: 19.008px; */
  /* line-height: 23.9936px;  */
  letter-spacing: 10px;
}
main .line {
  width: 100%;
  margin-top: 63px;
  height: 4px;
  background-color: rgba(239, 239, 242, 0.5);
}

main h1 {
  margin: 39.9936px auto 22.0032px;
  font-size: 20px;
  font-weight: 600;
  color: #01021b;
  line-height: 28px;
}
main p {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #01021b;
  line-height: 24px;
  letter-spacing: 0.9984px;
}
.main .center .change {
  display: none;
}

.main .center .change.current {
  display: block;
  height: 160px;
}

.change h1 {
  font-size: 20px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/contact.vue